import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito experiencia previa?',
    answer: 'No. El sistema está diseñado paso a paso, con un lenguaje claro y accesible para cualquier persona, sin importar si es su primer acercamiento a la sanación emocional o constelaciones familiares.'
  }, {
    question: '¿Cuándo veo resultados?',
    answer: 'La toma de consciencia es inmediata. Al leer y hacer los primeros ejercicios, comenzarás a atar cabos sueltos de tu historia. La liberación emocional profunda depende de tu ritmo y compromiso con el proceso.'
  }, {
    question: '¿Cómo accedo al material?',
    answer: 'Una vez completado el pago, recibirás un correo electrónico de forma automática e inmediata con el acceso completo a todo el material digital para que puedas descargarlo y comenzar a tu propio ritmo.'
  }, {
    question: '¿Esto es lo mismo que ir a terapia?',
    answer: 'No reemplaza la terapia, pero la complementa de una forma muy poderosa. Este sistema te ayuda a identificar patrones heredados que muchas veces ni en terapia se abordan. Muchas personas lo usan junto a su proceso terapéutico y notan avances más profundos.'
  }, {
    question: '¿Funciona si no conozco la historia de mi familia?',
    answer: 'Sí. No necesitas conocer cada detalle de tu árbol genealógico. Los patrones emocionales heredados se manifiestan en tu cuerpo, tus relaciones y tus decisiones. El sistema te guía para reconocerlos desde tu propia experiencia, sin depender de lo que tu familia te haya contado.'
  }, {
    question: '¿Puedo compartirlo con alguien de mi familia?',
    answer: 'El material es para uso personal, pero muchas personas descubren que al sanar sus propios patrones, las dinámicas familiares comienzan a transformarse naturalmente. Si alguien de tu familia quiere hacer el proceso, puede adquirir su propio acceso.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <h2 className="font-playfair text-4xl md:text-5xl text-center text-dark mb-12" data-id="element-57">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-dark/5 overflow-hidden transition-all duration-300" data-id="element-59">
              <button onClick={() => toggleFAQ(index)} className="w-full px-8 py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-60">
                <span className="font-playfair text-xl text-dark font-medium pr-8" data-id="element-61">
                  {faq.question}
                </span>
                {openIndex === index ? <MinusIcon className="w-5 h-5 text-terracotta shrink-0" data-id="element-62" /> : <PlusIcon className="w-5 h-5 text-dark/40 shrink-0" data-id="element-63" />}
              </button>

              <div className={`px-8 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-64">
                <p className="text-dark/70 font-light leading-relaxed" data-id="element-65">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}